/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/iframe-has-title */
import {
  Box,
  Button,
  Card,
  CardContent,
  Modal,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import TimelineItem from "components/Icon/TimelineItem";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import ShowSwalWithButtons from "components/SwalAlert/swalPopupWithButtons";
import { useMaterialUIController } from "context";
import PageTitle from "examples/PageTitle/PageTitle";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { useEffect, useState } from "react";
// import DataTable from "react-data-table-component";
import DataTable, { createTheme } from "react-data-table-component";
import { useNavigate, useParams } from "react-router-dom";
import { appConstants } from "utils/appConstants";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { showResMsg } from "utils/generic";
import { useDispatch } from "react-redux";
import DownloadIcon from '@mui/icons-material/Download';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { downloadRCTI } from "utils/invoiceAPI";
import { PreviewRCTIDetails } from "utils/invoiceAPI";

const pdfStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  height: "90%x",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

createTheme(
  'solarized',
  {
    text: {
      primary: 'white',
      secondary: 'white',
    },
    background: {
      default: '#202940',
    },
    context: {
      background: '#202940',
      text: 'white',
    },
    divider: {
      default: 'white',
    },
    button: {
      default: '#ffff',
      hover: 'rgba(255, 255, 255, .18)',
      focus: 'rgba(255, 255, 255, .18)',
      disabled: 'rgba(255, 255, 255, .18)',
    },
    sortFocus: {
      default: '#ffff',
    },
  },
  'dark',
);
createTheme(
  'light',
  {
    text: {
      primary: 'black',
      secondary: 'black',
    },
    background: {
      default: 'white',
    },
    context: {
      background: 'white',
      text: 'black',
    },
    divider: {
      default: 'gray',
    },
    button: {
      default: '#00000',
      hover: 'rgba(0, 0, 0, .18)',
      focus: 'rgba(0, 0, 0, .18)',
      disabled: 'rgba(0, 0, 0, .18)',
    },
    sortFocus: {
      default: '#00000',
    },
  },
  'dark',
);



function PreviewRCTI() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id: rctiID, rctiNumber: rctiNo } = useParams();
  console.log(rctiID, rctiNo)
  const [controller] = useMaterialUIController();
  const { darkMode, sidenavColor } = controller;
  const { tableBorder } = getColorMappings(sidenavColor);
  const [getDocumentFileURL, setSetDocumentFileURL] = useState('');
  const [viewDocumentInModal, setViewDocumentInModal] = useState(false);

  const customStyles = {

    table: {

      style: {
        borderColor: "lightgray",
      },
    },
    headRow: {
      style: {
        minHeight: '30px'
      },
    },
    headCells: {
      style: {
        fontSize: "12px",
      },
    },
    cells: {
      style: {

      },
    },
  };

  const [values, setValues] = useState({
    customerCompanyName: '',
    customerStreetAddress: '',
    customerEmailAddress: '',
    rctiNumber: 'xxxxxx',
    purchaseOrderNumber: '',
    gstType: 'Inclusive',
    currencyValue: '',
    finalAmount: 0,
    paymentInstruction: '',
    totalAmount: 0,
    totalDiscountAmount: 0,
    rctiStatus: 'Unpaid',
    payablePendingAmount: 0,
    totalGSTAmount: 0,
    contactName: 'xxxxxxx',
    quotationDate: '',
    validUptoDate: '',
  });
  const [itemRowValues, setItemRowValues] = useState([]);
  const [documents, setDocuments] = useState([]);


  useEffect(() => {
    fetchInitialData();
  }, []);

  const fetchInitialData = async () => {
    PreviewRCTIDetails({ rctiID: rctiID }, (data) => {
      if (data.Result_Output.length > 0) {
        let result = data.Result_Output[0];
        console.log("fgfgdf", result)
        setValues(result);

        data.Result_Output.length > 0 && setItemRowValues(data.Result_Output);
        result.documentsList.length > 0 && setDocuments(result.documentsList);
      } else {
        showResMsg("Details couldn't find", 2000, false)
      }
    }, dispatch)
  }

  let columns = [
    {
      name: <p style={{ textAlign: "start", paddingLeft: "5px" }}>Item</p>,
      selector: row => row.itemName,
    },
    {
      name: `Item Description`,
      selector: row => row.itemDescription,
    },
    {
      name: "Item Quantitiy",
      selector: row => row.itemQuantity,
    },
    {
      name: `Item Price (${values.currencyValue})`,
      selector: row => row.itemPrice,
    },
    {
      name: "Account",
      selector: row => row.categoryCodeName,
    },
    {
      name: "GST%",
      selector: row => row.gst,
    },
    // {
    //   name: "Discount Type",
    //   selector: row => row.discountType,
    // },
    // {
    //   name: "Discount Value",
    //   selector: row => row.discountValue,
    // },

  ];
  const documentColumns = [
    {
      name: "Document Name",
      selector: (row) => row.documentName,

    },
    {
      name: <p style={{ textAlign: "center" }}>Action</p>,
      selector: (row) => row,
      center: "true",
      cell: (row) => (
        <>
          <Grid mt={-3.2}>
            <TimelineItem
              color="info"
              icon="visibility"
              onClick={() => { handleViewDocument(row) }}
              title="View"
            />
          </Grid>


        </>
      ),
    },
  ];

  //View Document Fxn
  const handleViewDocument = (selectedDocRow) => {
    setSetDocumentFileURL(appConstants.baseURL + 'quotation/viewUploadedQuotationDocument?fileName=/' + selectedDocRow.documentFileName);
    setViewDocumentInModal(true);
  };

  const handleDownload = async () => {

    await downloadRCTI({ _id: rctiID }, async (response) => {

      const pdfContent = response.data;
      const binaryPdfData = atob(pdfContent);

      const arrayBuffer = new ArrayBuffer(binaryPdfData.length);
      const uint8Array = new Uint8Array(arrayBuffer);
      for (let i = 0; i < binaryPdfData.length; i++) {
        uint8Array[i] = binaryPdfData.charCodeAt(i);
      }
      const blob = new Blob([arrayBuffer], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank');
      ShowSwalWithButtons(
        '', `Would you like to download the RCTI?`, 'question', darkMode,
        () => {
          const link = document.createElement('a');
          link.href = url;
          link.download = `rcti_${rctiNo}.pdf`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      );
    }, dispatch)


  };
  return (
    <DashboardLayout >
      <DashboardNavbar />
      <Grid sx={{ mt: 2, mb: 2 }}>
        <Card color="primary" sx={{ pb: 2, boxShadow: "3px 3px 3px 3px #cdcdcd" }}>
          <PageTitle screenName="RCTI Preview" />
          <Grid container px={3} mt={2} spacing={2}>
            <Grid item lg={6} xs={6}>
              <Box>
                <MDTypography style={{ fontSize: "1rem", fontWeight: "600", color: tableBorder }}>
                  {values.customerCompanyName} <span style={{ marginLeft: 1, fontSize: "0.75rem", color: "green", fontWeight: "600" }}>{values.rctiStatus}</span>
                </MDTypography>
                <MDTypography style={{ fontSize: "0.75rem", display: 'flex', alignItems: 'center' }}>
                  <Box component="span" sx={{ display: 'flex', alignItems: 'center', marginRight: 1 }}>
                    <PersonIcon />
                    <Box component="span" sx={{ marginLeft: 1 }}>{values.contactName} </Box>
                  </Box>
                  <Box component="span" sx={{ display: 'flex', alignItems: 'center', marginLeft: 1, marginRight: 1 }}>
                    <EmailIcon />
                    <Box component="span" sx={{ marginLeft: 1 }}>{values.customerEmailAddress}</Box>
                  </Box>

                </MDTypography>
                <MDTypography style={{ fontSize: "0.75rem", display: 'flex', alignItems: 'center' }}>
                  <LocationOnIcon />
                  <Box component="span" sx={{ marginLeft: 1 }}>{values.customerStreetAddress}</Box>
                </MDTypography>
              </Box>
            </Grid>

            <Grid item lg={6} xs={6} style={{ display: 'flex', justifyContent: 'end' }}>
              <Button>
                <MDTypography variant="h6" style={{ fontSize: "0.75rem", display: 'flex', alignItems: 'center', border: "1px solid #1ed6c9", borderRadius: "5px", color: '#1ed6c9', padding: "3.75px 10px" }}>
                  <Box component="span" sx={{ display: 'flex', alignItems: 'center', marginRight: 1 }}>
                    <DownloadIcon />
                    <Box component="span" sx={{ marginLeft: 1 }} onClick={handleDownload}>Print/Download</Box>
                  </Box>
                </MDTypography>
              </Button>

            </Grid>
          </Grid>

          <Box component="section">
            <Box>
              <Grid container px={3} mt={2} spacing={2} >
                <Grid item lg={2} xs={4}>
                  <Box>
                    <Typography style={{ fontSize: "0.75rem", fontWeight: "600", color: `${darkMode ? "white" : "black"}` }}>Quotation No.</Typography>
                    <Typography style={{ fontSize: "0.75rem", color: '#1ed6c9', fontWeight: "600" }}>{values.rctiNumber}</Typography>
                  </Box>
                </Grid>

                <Grid item lg={1.5} xs={4}>
                  <Box  >
                    <Typography style={{ fontSize: "0.75rem", fontWeight: "600", color: `${darkMode ? "white" : "black"}` }}>Issue Date</Typography>
                    <Typography style={{ fontSize: "0.75rem", color: `${darkMode ? "white" : "black"}` }}>{values.quotationDate}</Typography>
                  </Box>
                </Grid>



                <Grid item lg={1.5} xs={4}>
                  <Box  >
                    <Typography style={{ fontSize: "0.75rem", fontWeight: "600", color: `${darkMode ? "white" : "black"}` }}>Due Date</Typography>
                    <Typography style={{ fontSize: "0.75rem", color: `${darkMode ? "white" : "black"}` }}>{values.validUptoDate}</Typography>
                  </Box>
                </Grid>

                <Grid item lg={1.5} xs={4}>
                  <Box  >
                    <Typography sx={{ ml: 0.7 }} style={{ fontSize: "0.75rem", fontWeight: "600", textAlign: "start", color: `${darkMode ? "white" : "black"}` }}>Status</Typography>
                    <Typography sx={{ ml: 0.7 }} style={{ fontSize: "0.75rem", color: "green", fontWeight: "600" }}>{values.rctiStatus}</Typography>
                  </Box>
                </Grid>

                <Grid item lg={1.5} xs={4}>
                  <Box  >
                    <Typography style={{ fontSize: "0.75rem", fontWeight: "600", color: `${darkMode ? "white" : "black"}` }}>Currency</Typography>
                    <Typography style={{ fontSize: "0.75rem", color: `${darkMode ? "white" : "black"}` }}>{values.currencyValue}</Typography>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box >


          <Box display="flex" justifyContent="end" mt={2}>
            <Typography px={2.5} style={{ fontSize: "0.75rem", textAlign: "center", color: `${darkMode ? "white" : "black"}` }}>Amounts are tax <span style={{ color: "green", fontWeight: "400" }}>{values.gstType}</span></Typography>
          </Box>
          <CardContent>
            <DataTable
              theme={darkMode ? 'solarized' : 'light'}
              columns={columns}
              data={itemRowValues}
              customStyles={customStyles}

            />
          </CardContent>


          <Box mt={1.5} display="flex" justifyContent="flex-end" >
            <Box>
              <Box display="flex" justifyContent="space-between" mt={1}>
                <MDTypography style={{ fontSize: "14px", fontWeight: "400" }}>Total Amount </MDTypography>
                <Box px={4} sx={{ ml: { xs: 2, sm: 34, md: 15 } }} >
                  <MDTypography style={{ fontSize: "14px" }} >{values.currencyValue} {(parseFloat(values.totalAmount)).toFixed(2)}</MDTypography>
                </Box>
              </Box>
              <Box display="flex" justifyContent="space-between" mt={1}>
                <MDTypography style={{ fontSize: "14px", fontWeight: "400" }}>Total Discount </MDTypography>
                <Box px={4}   >
                  <MDTypography style={{ fontSize: "14px" }}>{values.currencyValue} {(parseFloat(values.totalDiscountAmount)).toFixed(2)}</MDTypography>
                </Box>
              </Box>
              <Box display="flex" justifyContent="space-between" mt={1}>
                <MDTypography style={{ fontSize: "14px", fontWeight: "400", }} >Total GST </MDTypography>
                <Box px={4} >
                  <MDTypography style={{ fontSize: "14px" }} > {values.currencyValue} {(parseFloat(values.totalGSTAmount)).toFixed(2)}</MDTypography>
                </Box>
              </Box>
              <hr style={{ marginRight: "35px" }} />

              <Box display="flex" justifyContent="space-between" mt={1}>
                <MDTypography style={{ fontSize: "14px", fontWeight: "600" }} >Grand Total </MDTypography>
                <Box px={4} sx={{ ml: 2 }}>
                  <MDTypography style={{ fontSize: "14px", fontWeight: "600" }} >{values.currencyValue} {(parseFloat(values.finalAmount)).toFixed(2)}</MDTypography>
                </Box>
              </Box>
            </Box>
          </Box>
          {documents.length > 0 && <>
            <Grid item xs={12} px={2} mt={2.5} md={4} lg={12}>
              <Typography
                variant="button"
                fontWeight="bold"
                color="text"
                sx={{ cursor: "pointer", userSelect: "none" }}
              >
                Attached Documents
              </Typography>
            </Grid>
            <CardContent >
              < DataTable

                columns={documentColumns}
                data={documents}
                customStyles={customStyles}

              />
            </CardContent>
          </>}


        </Card>
        <Grid
          container
          mt={2}
          pb={3}
          spacing={2}
          alignItems="center"
          justifyContent="center"
          display="flex"
        >
          <Grid item container xs={12} md={4} lg={1.8} justifyContent="center">

            <MDButton
              className="btn-block center-container-btn btn-warning btn-back rightSpace"
              color="warning"
              style={{ height: "40px", width: "165px" }}
              onClick={() => { navigate('/rcti') }}
            >
              Close
            </MDButton>

          </Grid>
        </Grid>


      </Grid>

      {
        viewDocumentInModal && <Modal
          open={viewDocumentInModal}
          onClose={() => setViewDocumentInModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{
          }}
        >
          <Card sx={pdfStyle}>

            {/* <Card sx={pdfStyle}> */}
            <Box>
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
              >
                File Viewer
              </Typography>
              <iframe title="File Viewer" src={getDocumentFileURL} width="100%" height="650" className="ressst" allowFullScreen={true} ></iframe>

              <Grid container id="modal-modal-description" sx={{ mt: 2, justifyContent: "center" }}>
                <MDButton color="warning" className="modalButton" onClick={() => { setViewDocumentInModal(false) }}>
                  Close
                </MDButton>
              </Grid>
            </Box>
          </Card>
        </Modal>
      }

    </DashboardLayout >
  )
}

export default PreviewRCTI;
